module.exports = __webpack_public_path__ + "media/images/twitter-7e281db995ae2e6d9a7f853aeff83c2e.png";